import React, { useState, useEffect } from 'react';
import { ethers } from "ethers";

import '../Styles/DappMain.css';
import ERC20_Transfer from './ERC20_Transfer';
import Native_Transfer from './Native_Transfer';
import UniSwap_SWAP from './UniSwap_SWAP';
import { CommandType, RoutePlanner } from "./../tools/UniSwap/routePlanner.js"
import * as configWidget from '../configWidget';

const DappMain = ({ title, blockchainInfo, setUserMessage, setShowWidget, setShowPrimaryButton, showPrimaryButton }) => {
    const [areFieldsValid, setAreFieldsValid] = useState(false);
    const [userData, setData] = useState("");

    const PEMIT_ADDR = "0x000000000022D473030F116dDEE9F6B43aC78BA3"
    const DEADLINE = 2000000000

    // v3 from UNISWAP
    const FEE_SIZE = 3;
    function encodePath(path, fees) {
        if (path.length !== fees.length + 1) {
            throw new Error('path/fee lengths do not match');
        }

        let encoded = '0x';
        for (let i = 0; i < fees.length; i++) {
            // 20 byte encoding of the address
            encoded += path[i].slice(2);
            // 3 byte encoding of the fee
            encoded += fees[i].toString(16).padStart(2 * FEE_SIZE, '0');
        }
        // encode the final token
        encoded += path[path.length - 1].slice(2);

        return encoded.toLowerCase();
    }

    function encodePathExactInput(tokens) {
        return encodePath(tokens, new Array(tokens.length - 1).fill(3000));
    }

    useEffect(() => {
        window.addEventListener('message', handleIframeMessage);

        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, []);

    function handleIframeMessage(event) {
        if (event.origin !== "https://surfermonkey.github.io/surfermonkey.widget.v1.github.io/") {
            return;
        }

        const dataFromWidget = event.data;
        // Handle the data as needed
        console.log("Widget speaks: ", event)
    }

    // ***********************************************
    // Developer: START Capture data from the user
    // ***********************************************
    async function captureData(_title, _blockchainInfo, _userData) {
        let func = 0
        let tokenAddressAux = ""
        let functionHeader = ""
        let functionName = ""
        let payloadParmsArr
        let decimalsAux = _userData.tokenDecimals
        let amountAux = ethers.parseUnits(_userData.amount + "", decimalsAux) + "";
        let targetSCAux = []
        let payload_data_Arr = []
        let payloadAmountPerCall_Arr = []
        const proxyAddress = _blockchainInfo.supportedDapps[0].address
        const uniswapAddress = _blockchainInfo.supportedDapps[2].address

        if ("Native Transfer" === _title) {
            func = 1
            functionHeader = _blockchainInfo.supportedDapps[0].functions[0].header // Dapp index 0, and function index 0
            functionName = _blockchainInfo.supportedDapps[0].functions[0].name
            payloadParmsArr = [_userData.recipientAddress, amountAux]
            targetSCAux.push(proxyAddress) // Proxy address

            // The function header from the target function. String
            // The function name from the target function. String
            // The target function parameters. Array of strings
            payload_data_Arr.push({ functionHeader, functionName, payloadParmsArr })
            payloadAmountPerCall_Arr.push(amountAux)
        }
        if ("ERC20 Transfer" == _title) {
            func = 2
            tokenAddressAux = _userData.tokenAddress
            functionHeader = _blockchainInfo.supportedDapps[1].functions[0].header // Dapp index 1, and function index 0
            functionName = _blockchainInfo.supportedDapps[1].functions[0].name
            payloadParmsArr = [_userData.recipientAddress, amountAux]
            targetSCAux.push(_userData.tokenAddress)

            // The function header from the target function. String
            // The function name from the target function. String
            // The target function parameters. Array of strings
            payload_data_Arr.push({ functionHeader, functionName, payloadParmsArr })

            payloadAmountPerCall_Arr.push(amountAux)
        }
        if ("UniSwap Swap" == _title) {
            // New UniSwap Planner
            let planner
            planner = new RoutePlanner()

            func = _userData.func
            // Add Smart Contract addresses
            const inputTokenAddress = _userData.tokenAddress
            const outputTokenAddress = _userData.tokenOutput
            const swapRecipient = _userData.recipientAddress
            targetSCAux.push(inputTokenAddress) // First approve the spend from Token ERC20, either starting with the wETH or another token
            targetSCAux.push(PEMIT_ADDR) // Second call Approve in Permit from UniSwap
            targetSCAux.push(uniswapAddress) // third, call UniSwap

            // Add Payload amount per call
            payloadAmountPerCall_Arr.push("0")
            payloadAmountPerCall_Arr.push("0")

            // Add Payload data

            // Approve ERC20 Spend
            let functionHeaderFirst = _blockchainInfo.supportedDapps[2].functions[0].header
            let functionNameFirst = _blockchainInfo.supportedDapps[2].functions[0].name
            let payloadParmsArrFirst = [PEMIT_ADDR, amountAux]
            payload_data_Arr.push({ functionHeader: functionHeaderFirst, functionName: functionNameFirst, payloadParmsArr: payloadParmsArrFirst })

            // Approve UniSwap Permit2
            let functionHeaderSecond = _blockchainInfo.supportedDapps[2].functions[1].header
            let functionNameSecond = _blockchainInfo.supportedDapps[2].functions[1].name
            let payloadParmsArrSecond = [
                inputTokenAddress, // Token address
                uniswapAddress, // UniSwap Address
                "99999999999999999999999999999999999999999999999", // Max amount
                DEADLINE + "" // some far away deadline
            ]
            payload_data_Arr.push({ functionHeader: functionHeaderSecond, functionName: functionNameSecond, payloadParmsArr: payloadParmsArrSecond })

            // If user Journey started from Native
            if (func == 1) {
                payloadAmountPerCall_Arr.push(amountAux)

                // Add UniSwap
                let functionHeaderThird = _blockchainInfo.supportedDapps[2].functions[2].header
                let functionNameThird = _blockchainInfo.supportedDapps[2].functions[2].name

                planner.addCommand(CommandType.WRAP_ETH, [proxyAddress, amountAux])
                const auxPath = encodePathExactInput([inputTokenAddress, outputTokenAddress])
                planner.addCommand(
                    CommandType.V3_SWAP_EXACT_IN,
                    [
                        swapRecipient,
                        amountAux,
                        1, // dummy value
                        auxPath,
                        true
                    ]
                )
                let payloadParmsArrThird = [planner.commands, planner.inputs]
                payload_data_Arr.push({ functionHeader: functionHeaderThird, functionName: functionNameThird, payloadParmsArr: payloadParmsArrThird })
            }

            // If user Journey started from ERC20
            if (func == 2) {
                tokenAddressAux = inputTokenAddress
                payloadAmountPerCall_Arr.push("0")

                // Add UniSwap
                let functionHeaderThird = _blockchainInfo.supportedDapps[2].functions[2].header
                let functionNameThird = _blockchainInfo.supportedDapps[2].functions[2].name
                const auxPath = encodePathExactInput([inputTokenAddress, outputTokenAddress])
                planner.addCommand(
                    CommandType.V3_SWAP_EXACT_IN,
                    [
                        proxyAddress,
                        amountAux,
                        1, // dummy value
                        auxPath,
                        true
                    ]
                )
                //planner.addCommand(CommandType.UNWRAP_WETH, [swapRecipient, 0])
                let payloadParmsArrThird = [planner.commands, planner.inputs]
                payload_data_Arr.push({ functionHeader: functionHeaderThird, functionName: functionNameThird, payloadParmsArr: payloadParmsArrThird })

                // Add manual Unrwap and transfer
                const functionHeader_Unwrap_ProxySC = _blockchainInfo.supportedDapps[2].functions[3].header
                const functionName_Unwrap_ProxySC = _blockchainInfo.supportedDapps[2].functions[3].name
                const payload_ParamsArray_Unwrap_ProxySC =
                    [
                        swapRecipient,
                        outputTokenAddress
                    ]
                payload_data_Arr.push(
                    {
                        functionHeader: functionHeader_Unwrap_ProxySC,
                        functionName: functionName_Unwrap_ProxySC,
                        payloadParmsArr: payload_ParamsArray_Unwrap_ProxySC
                    }
                )
                targetSCAux.push(proxyAddress)
                payloadAmountPerCall_Arr.push("0") // 4 total calls
            }
        }

        const ERC20_SC = tokenAddressAux //  Only used for ERC20, blank string if not used. Hex String
        const targetBlockchainString = blockchainInfo.sourceChainId // Check config file for supported blockchains. Integer
        const sourceBlockchainString = blockchainInfo.sourceChainId
        const selectedFunc = func// (Native: nativeFunc = 1) OR (ERC20: erc20Func = 2). Integer
        const amount = amountAux// The amount of value of ERC20 or Native to be locked in the System. BigInt String without the 'n'
        const targetSCArr = targetSCAux // The target Smart Contract Address. Hex String
        const decimals = decimalsAux

        const UniversalPluginGlobalHash = _blockchainInfo.universalUP[0].globalHash // Version UP 1 for this specific blockchain
        const UniversalPluginAdress = _blockchainInfo.universalUP[0].address

        // Convert the data into a SurferMonkey Intent object
        const userIntent = configWidget.createUserMessage(
            selectedFunc,
            targetBlockchainString,
            sourceBlockchainString,
            ERC20_SC,
            amount,
            decimals,
            payload_data_Arr,
            payloadAmountPerCall_Arr,
            targetSCArr,
            UniversalPluginGlobalHash,
            UniversalPluginAdress
        )
        return userIntent
    }

    // ***********************************************
    // Developer: END Capture data
    // ***********************************************

    const handleUserData = async () => {
        console.log(userData)
        let surferMonkeyIntent = await captureData(title.name, blockchainInfo, userData)
        console.log("INENT", surferMonkeyIntent)
        setUserMessage(surferMonkeyIntent);
        // Open the widget or perform other actions here
        setShowWidget(true);
    };

    return (
        <div className="dapp-container">
            <h3 className='dAppName'>{title.name}</h3>
            {title.name === "ERC20 Transfer" &&
                <ERC20_Transfer
                    blockchainInfo={blockchainInfo}
                    setData={setData}
                    setAreFieldsValid={setAreFieldsValid}
                    setShowPrimaryButton={setShowPrimaryButton}
                />
            }
            {title.name === "Native Transfer" &&
                <Native_Transfer
                    blockchainInfo={blockchainInfo}
                    setData={setData}
                    setAreFieldsValid={setAreFieldsValid}
                    setShowPrimaryButton={setShowPrimaryButton}
                />
            }
            {/*title.name === "UniSwap Swap" &&
                <UniSwap_SWAP
                    blockchainInfo={blockchainInfo}
                    setData={setData}
                    setAreFieldsValid={setAreFieldsValid}
                    setShowPrimaryButton={setShowPrimaryButton}
                />
            */}
            {showPrimaryButton && areFieldsValid && (
                <button className="primary-button" type="submit" onClick={handleUserData} disabled={!areFieldsValid}>SEND ANONYMOUS INTENT</button>

            )}
        </div>
    );
}

export default DappMain;